<template>
    <v-dialog v-model="dialog" max-width="700px" @click:outside="hide" scrollable>
        <v-card tile>
            <v-card-title>
                <v-icon color="black" left size="40">
                    {{ editMode ? 'mdi-file-document-edit-outline' : 'mdi-file-document-plus-outline' }}
                </v-icon>
                <div class="title-dialog">
                    {{ editMode ? 'Edit expense (editar gasto):' : 'Add expense (agregar gasto):' }} {{ code }}
                    <div class="title-subtext">
                        Completa los siguientes datos
                    </div>
                </div>
                <v-spacer />
                <v-btn icon color="accent" large @click="hide">
                    <v-icon large>mdi-close-circle-outline</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="6">
                        <kimsa-date-picker label="Date (Fecha):" bolder-label outlined solo flat dense force-value
                            :value="date" @change="date = $event" />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-select label="Type of receipt (Tipo de recibo)" bolder-label :items="expenseItemTypes"
                            outlined solo flat dense item-text="name" item-value="id" force-value
                            :value="expense_item_type_id" @change="expense_item_type_id = $event" />
                    </v-col>
                    <v-col cols="12">
                        <kimsa-text-field label="Description (Glosa)" bolder-label outlined solo flat dense force-value
                            :value="name" disableDots @change="name = $event" />
                    </v-col>
                    <v-col cols="12">
                        <kimsa-select label="Accounting Account (Cuenta contable)" bolder-label
                            :items="expenseItemAccounts" outlined solo flat dense item-text="name" item-value="id"
                            force-value :value="expense_item_account_id" @change="expense_item_account_id = $event" />
                        <div class="explain-text">
                            Please select the accounting account for this expenses / favor seleccionar cuenta
                            contable para este gasto
                        </div>
                    </v-col>
                    <v-col cols="6">
                        <kimsa-text-field label="Receipt's number (numero de recibo)" bolder-label outlined dense
                            force-value :value="receipt_number" @change="receipt_number = $event" inputMode="numeric"
                            disableDots />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-file label="Image receipt (imagen comprobante)" bolder-label outlined dense
                            @change="file = $event;" :placeholder="filename" mimeType="image/*" :canDelete="canDelete"
                            @delete="handleImageDelete" ref="file" />
                    </v-col>
                    <v-col cols="2" class="amount-text">
                        CLP/Soles
                    </v-col>
                    <v-col cols="10">
                        <v-switch v-model="usdInputActive" label="USD" inset hide-details />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-text-field label="USD" bolder-label outlined solo flat dense force-value
                            :value="amount_usd" inputMode="numeric" allowDecimals disableDots @change="onUsdChange"
                            :readonly="!usdInputActive" />
                    </v-col>
                    <v-col cols="6">
                        <kimsa-text-field label="CLP/Soles" bolder-label outlined solo flat dense force-value
                            :value="amount_clp" inputMode="numeric" allowDecimals disableDots @change="onClpChange"
                            :readonly="usdInputActive" />
                    </v-col>
                    <v-col cols="12" align="center">
                        <v-btn @click="editMode ? editExpenseItem() : saveExpenseItem()" tile color="primary" depressed
                            :disabled="!valid" :loading="loading">
                            Add (agregar)
                        </v-btn>
                    </v-col>
                    <v-col cols="12" class="explain-text">
                        <b>Note:</b> Make sure you have the receipt images in digital format so you can select and
                        upload them, associating them with each expense.
                        <br>
                        <b>Nota:</b> preocúpese de tener las imágenes de los recibos ya en formato digital para poder
                        seleccionarlos y subirlos asociándolos a cada gasto.
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

    </v-dialog>
</template>

<script>

import { mapMutations, mapState } from "vuex";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import Axios from "@/utils/Axios";
import KimsaDatePicker from '../inputs/KimsaDatePicker.vue';
import KimsaSelect from '../inputs/KimsaSelect.vue';
import KimsaFile from '../inputs/KimsaFile.vue';

export default {
    name: "CreateExpenseItemDialog",
    components: { KimsaTextField, KimsaDatePicker, KimsaSelect, KimsaFile },
    data() {
        return {
            dialog: false,
            loading: false,
            editMode: false,
            exchangeRate: 1,
            expenseReport: null,
            expenseReportId: null,
            expenseItem: null,
            expenseItemTypes: [],
            expenseItemAccounts: [],
            date: this.$moment().format('YYYY-MM-DD'),
            receipt_number: '',
            expense_item_type_id: '',
            expense_item_account_id: '',
            name: '',
            amount_usd: '',
            amount_clp: '',
            filename: 'Upload receipt (cargar recibo)',
            file: null,
            usdInputActive: true,
            imgDelete: false,
        }
    },
    computed: {
        ...mapState(['dialogActive']),
        valid(vm = this) {
            return !!vm.date && !!vm.receipt_number && !!vm.expense_item_type_id && !!vm.expense_item_account_id && !!vm.name && !!vm.amount_usd && !!vm.amount_clp
        },
        canDelete(vm = this) {
            return !!vm.expenseItem?.filepath
        },
        code(vm = this) {
            return vm.expenseReport?.code || ''
        }
    },
    mounted() {
        const vm = this;
        vm.loadExpenseItemTypes();
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        async show(id, expenseReport) {
            const vm = this
            vm.expenseReportId = id
            vm.expenseReport = expenseReport
            vm.exchangeRate = expenseReport.exchange_rate
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            setTimeout(() => {
                vm.reset()
            }, 500)
        },
        reset() {
            const vm = this
            vm.editMode = false
            vm.expenseReportId = null
            vm.expenseReport = null
            vm.expenseItem = null
            vm.date = vm.$moment().format('YYYY-MM-DD')
            vm.receipt_number = ''
            vm.expense_item_type_id = ''
            vm.expense_item_account_id = ''
            vm.name = ''
            vm.amount_usd = ''
            vm.amount_clp = ''
            vm.filename = 'Upload receipt (cargar recibo)'
            vm.file = null
            if (vm.$refs.file) vm.$refs.file.reset()
        },
        async loadExpenseItemTypes() {
            const vm = this;
            if (vm.expenseItemTypes.length > 0) return;
            await Axios.get(`expense-reports/items/options`).then(res => {
                // console.log('res loadExpenseItemTypes', res)
                vm.expenseItemTypes = res.data.result.expenseItemTypes
                vm.expenseItemAccounts = res.data.result.expenseItemAccounts
            }).catch(er => {
                console.log('error loadExpenseItemTypes', er)
            })
        },
        async loadExpenseItem(id, expenseReport) {
            const vm = this
            await Axios.get(`expense-reports/items/${id}`).then(res => {
                // console.log('res loadExpenseReport', res)
                vm.expenseItem = res.data.result.expenseItem
                vm.editMode = true
                vm.date = vm.$moment(vm.expenseItem.date).format('YYYY-MM-DD')
                vm.receipt_number = vm.expenseItem.receipt_number
                vm.expense_item_type_id = vm.expenseItem.expense_item_type_id
                vm.expense_item_account_id = vm.expenseItem.expense_item_account_id
                vm.name = vm.expenseItem.name
                vm.amount_usd = vm.expenseItem.amount_usd
                vm.amount_clp = vm.expenseItem.amount_clp
                vm.filename = vm.expenseItem.filename || 'Upload receipt (cargar recibo)'
                vm.show(vm.expenseItem.expense_report_id, expenseReport)
            }).catch(er => {
                console.log('error loadExpenseReport', er)
            })
        },
        async saveExpenseItem() {
            const vm = this
            vm.loading = true
            // console.log('saveExpenseReport', vm)

            let payload = new FormData()
            payload.append('expense_item_type_id', vm.expense_item_type_id)
            payload.append('expense_item_account_id', vm.expense_item_account_id)
            payload.append('date', vm.date)
            payload.append('receipt_number', vm.receipt_number)
            payload.append('name', vm.name)
            payload.append('amount_usd', vm.amount_usd)
            payload.append('amount_clp', vm.amount_clp)

            if (vm.file) payload.append('file', vm.file)

            // console.log('payload', payload)

            let headers = { headers: { 'Content-Type': 'multipart/form-data' } }
            await Axios.post(`expense-reports/${vm.expenseReportId}/items/new`, payload, headers).then(res => {
                // console.log('res saveExpenseReport',res)
                vm.toast('Gasto creado')
                vm.$emit('success')
                vm.hide()
            }).catch(error => {
                console.log('error saveExpenseReport', error)
                vm.toast('Ha ocurrido un error', 'error')
            }).finally(() => {
                vm.loading = false
            })
        },
        async editExpenseItem() {
            const vm = this
            vm.loading = true

            // console.log('editExpenseReport', vm)

            let payload = new FormData()
            payload.append('_method', 'PATCH');
            payload.append('expense_item_type_id', vm.expense_item_type_id)
            payload.append('expense_item_account_id', vm.expense_item_account_id)
            payload.append('date', vm.date)
            payload.append('receipt_number', vm.receipt_number)
            payload.append('name', vm.name)
            payload.append('amount_usd', vm.amount_usd)
            payload.append('amount_clp', vm.amount_clp)

            if (vm.file) payload.append('file', vm.file)
            if (vm.imgDelete) payload.append('imgDelete', true)

            // console.log('payload', payload)

            let headers = { headers: { 'Content-Type': 'multipart/form-data' } }
            await Axios.post(`expense-reports/items/${vm.expenseItem.id}/edit`, payload, headers).then(res => {
                // console.log('res editExpenseReport',res)
                vm.toast('Gasto editado')
                vm.$emit('success')
                vm.hide()
            }).catch(error => {
                console.log('error editExpenseReport', error)
                vm.toast('Ha ocurrido un error', 'error')
            }).finally(() => {
                vm.loading = false
            })
        },
        onUsdChange(val) {
            this.amount_usd = val
            if (this.exchangeRate && this.usdInputActive) {
                this.amount_clp = val ? +(val * this.exchangeRate).toFixed(0) : null
            }
        },
        onClpChange(val) {
            this.amount_clp = val
            if (this.exchangeRate && !this.usdInputActive) {
                this.amount_usd = val ? +(val / this.exchangeRate).toFixed(2) : null
            }
        },
        handleImageDelete() {
            this.imgDelete = true;
            this.file = null;
            this.filename = 'Upload receipt (cargar recibo)';
        }
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>
.title-dialog {
    color: var(--v-primary-base);
    font-size: 20px;
    font-weight: bold;
    text-transform: uppercase;
}

.title-subtext {
    font-size: 11px;
    color: #a8a8a8;
    line-height: .5;
    text-transform: none;
    font-weight: normal;
}

.label {
    font-size: 15px;
    color: #333333;
}

.amount-text {
    display: flex;
    align-items: flex-end;
    color: rgba(0, 0, 0, 0.6);
    font-size: 16px;
}
</style>